
const Moe = window.moe({
  app_id: process.env.REACT_APP_MOENGAGE_KEY,
  debug_logs: process.env.REACT_APP_MOENGAGE_DEBUG_LOGS
});

export const Moengage = {

  trackEvent: (eventName, eventData) => {
    Moe.track_event(eventName, eventData);
  },

  userLogin: (user) => {
    Moe.add_unique_user_id(user.id);
    Moe.add_user_attribute("fo_id" , user.entityId);
  },

  userLogout: () => {
    Moe.destroy_session();
  }
};